export const SIMULATOR_LINK = 'https://app.plcsimulator.online/';
export const DISCORD_LINK = 'https://discord.gg/7XKvR2qvtM';
